import config from '@config/config';

import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';

const REQUEST_PROMO_SUBMIT_BASE_PATH = `${config.dashboardServiceBasePath}/dashboard/v1/promotions/code`;

const { POST } = api;

export interface RequestPromotion {
  postPromoCode: ResourceFetch<any, { code: string }>;
}

const RequestPromotion: RequestPromotion = {
  postPromoCode: POST(`${REQUEST_PROMO_SUBMIT_BASE_PATH}`),
};

export default RequestPromotion;
